import { toUser } from '@data/dto/user.dto';
import { User } from '@data/models/user.interface';
import { ActionStore } from '@stores/models/store';
import * as Reducers from '@stores/reducers/Reducers';

const initialState: User = toUser({});

const reducer = (state = initialState, action: ActionStore<User>): User => {
  switch (action.type) {
    case Reducers.SET_USER:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
